<wbo-edit-page #editPage [title]="model.data.name">
    <fui-formation-group-template *formationGroup="{title: 'wbo.tax.edit.formation.details', formControlNames: ''}">
        <fui-rows [formGroup]="editPage.formGroup">
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-text-edit-control formControlName="name"
                                               [(ngModel)]="model.data.name"></wbo-text-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-single-select-edit-control formControlName="method" [(ngModel)]="model.data.method"
                                                        [allowClearSelectionOption]="false" (onSelect)="methodSelect()">
                            <wbo-select-options>
                                <wbo-select-option [value]="TaxData.ADDITIVE_METHOD"
                                                   label="wbo.tax.option.method.additive">
                                </wbo-select-option>
                                <wbo-select-option [value]="TaxData.SUBTRACTIVE_METHOD"
                                                   label="wbo.tax.option.method.subtractive">
                                </wbo-select-option>
                            </wbo-select-options>
                        </wbo-single-select-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-numeric-edit-control formControlName="percent"
                                                  [(ngModel)]="model.data.percent"></wbo-numeric-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-numeric-edit-control formControlName="priority"
                                                  [(ngModel)]="model.data.priority"></wbo-numeric-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
            <fui-row>
                <fui-two-columns>
                    <fui-column>
                        <wbo-checkbox-edit-control formControlName="excludedFromBasePrice"
                                                   [(ngModel)]="model.data.excludedFromBasePrice"
                                                   [readonly]="model.data.method === TaxData.SUBTRACTIVE_METHOD"></wbo-checkbox-edit-control>
                    </fui-column>
                    <fui-column>
                        <wbo-checkbox-edit-control formControlName="defaultTax"
                                                   [(ngModel)]="model.data.defaultTax"></wbo-checkbox-edit-control>
                    </fui-column>
                </fui-two-columns>
            </fui-row>
        </fui-rows>
    </fui-formation-group-template>
</wbo-edit-page>
